// filepath: /Users/paulojustinchan/Downloads/workspace/PriveMD/achieve-admin-frontend/src/reducers/store.js
import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import alertReducer from "./alertSlice";
import loaderReducer from "./loaderSlice";
import patientReducer from "./patientSlice";
import permissionReducer from "./permissionSlice";

const store = configureStore({
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ["alertBox/showAlert"],
                // Ignore these field paths in all actions
                ignoredActionPaths: ["alertBox.buttons.*"],
                // Ignore these paths in the state
                ignoredPaths: ["alertBox.buttons"],
            },
        }),
    reducer: {
        loader: loaderReducer,
        alertBox: alertReducer,
        user: userReducer,
        patient: patientReducer,
        permission: permissionReducer,
    },
});

export default store;
